import { useToast } from "./components/hooks/use-toast";
import { useSelector } from "react-redux";
import { RootState } from "./store/store";
import { useEffect } from "react";
import { removeToastError } from "./store/flowSlice";
import { useDispatch } from "react-redux";

const GlobalToast = () => {
    const { toast } = useToast();
    const toastErrors = useSelector((state: RootState) => state.flow.toastErrors);
    const dispatch = useDispatch();

    useEffect(() => {
        toastErrors.forEach(error => {
            toast({
                title: "Error",
                description: error.message,
                variant: "destructive",
            })
            dispatch(removeToastError(error.id))
        })
    }, [toastErrors, toast])
    return (
        <div>
            {toastErrors.map((error, index) => (
                <div key={index}>
                    {error.message}
                </div>
            ))}
        </div>
    )
}

export default GlobalToast;